import React, { Component } from 'react';
import { Switch } from 'antd';
import VehiclePartnerApi from '../../functions/api/partner/VehiclePartner';
import NotifyAlert from '../../components/Notify/NotifyAlert';

export default class ButtonFeatured extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vehiclePart: props.row,
      check: props.row.isFeatured,
    };
  }

  componentWillReceiveProps(next) {
    this.setState({ vehiclePart: next.row, check: next.row.isFeatured });
  }

  handleChange = async (checked) => {
    const check = !checked;
    const { vehiclePart } = this.state;
    this.setState({ check: checked });
    const value = await VehiclePartnerApi.updateFeatured(
      vehiclePart.vhc_part_id,
      !check
    );
    if (!value || value.message) {
      NotifyAlert('Lỗi', 'Có lỗi khi đánh dấu nổi bật!');
    }
  };

  render() {
    const { check } = this.state;
    return <Switch onChange={this.handleChange} checked={check} />;
  }
}
